export const ADD_BILL_EVENT = 'Clicked Add Bill'

export const VERIFY_IDENTITY_EVENT = 'Clicked Verify Identity'
export const CONTINUE_VERIFICATION_EVENT = 'Clicked Continue Verification'
export const FAILED_VERIFICATION_EVENT = 'Failed Verification'
export const PASSED_VERIFICATION_EVENT = 'Passed Verification'

export const CONNECT_WALLET = 'Clicked Connect Wallet'
export const CONNECT_WALLET_STARTED = 'Wallet Connect Started'
export const CONNECT_WALLET_FAILED = 'Wallet Connect Failed'
export const DISCONNECT_WALLET = 'Clicked Disconnect Wallet'
export const WALLET_CONNECTED = 'Wallet Connected'

export const DIRECT_PAY_OPENED_EVENT = 'Direct Pay Opened'
export const DIRECT_PAY_STARTED_EVENT = 'Direct Pay Started'
export const DIRECT_PAY_COMPLETED_EVENT = 'Direct Pay Completed'
export const DIRECT_PAY_FAILED_EVENT = 'Direct Pay Failed'

export const TOKEN_APPROVAL_FAILED_EVENT = 'Token Approval Failed'
export const TOKEN_APPROVAL_SUCCEEDED_EVENT = 'Token Approval Succeeded'

export const BILL_ADDED_MANUALLY = 'Bill added manually'

export const ONBOARDING_STARTED = 'Onboarding Started'
export const ONBOARDING_CONNECT_WALLET = 'Onboarding Wallet Connected'
export const ONBOARDING_KYC = 'Onboarding KYC Completed'
export const ONBOARDING_SECURITY_QUESTIONS = 'Onboarding Security Questions Completed'
export const ONBOARDING_SECURITY_QUESTIONS_SKIPPED = 'Onboarding Security Questions Skipped'
export const ONBOARDING_BILL_PAYMENT_SKIPPED = 'Onboarding Bill Payment Skipped'
export const ONBOARDING_LINK_BILL = 'Onboarding Bill Linked'
export const ONBOARDING_BILL_PAID = 'Onboarding Bill Paid'
export const ONBOARDING_SKIPPED = 'Onboarding Skipped'

export const FEEDBACK_OPENED = 'Feedback Form Opened'
export const FEEDBACK_SUBMITTED = 'Feedback Form Submitted'

export const WALLET_DIALOG_OPENED = 'Wallet Dialog Opened'
export const NETWORK_SWITCHER_OPENED = 'Network Switcher Opened'
export const NETWORK_SWITCHED = 'Network Switched'

export const ADD_BANK_ACCOUNT_EVENT = 'Bank Accounts Clicked Add'

export const METHOD_FI_TOKEN_ERROR = 'Method Fi Token Error'
export const METHOD_FI_AUTHENTICATION_STARTED = 'Method Fi Authentication Started'
export const METHOD_FI_AUTHENTICATION_CLOSED = 'Method Fi Authentication Closed'
export const METHOD_FI_AUTHENTICATION_SUCCESS = 'Method Fi Authentication Completed'
export const METHOD_FI_AUTHENTICATION_ERROR = 'Method Fi Authentication Error'

export const SET_UP_SMART_PAY = 'Clicked Configure Subscription'
export const CONFIRM_SMART_PAY = 'Clicked Confirm Subscription'
export const SMART_PAY_MESSAGE_SIGNED = 'Signed Subscription Message'
export const SMART_PAY_MESSAGE_REJECTED = 'Rejected Signed Message'
